import { useState } from "react";
import { FieldValues, Path, useController } from "react-hook-form";

import { FormRow, SelectSheet } from "../../../components/MobileForm";
import {
  Card,
  CardLabel,
  HelperText,
  RowsCard,
} from "../../../components/MobileForm/styles";
import { FormMoneyInput, SelectOptionTypes } from "../../../components/Input";
import {
  CASHBACK_AMOUNT_LABEL,
  CASHBACK_SOURCE_HELPER,
  CASHBACK_SOURCE_LABEL,
} from "./constants";
import { cashbackRule, cashbackSourceRule } from "./tradeValidation";
import {
  CashbackFundingFieldsProps,
  CashbackFundingFormValues,
  ChargeFormValues,
} from "./types";

export const MobileCashbackFundingFields = <
  T extends FieldValues & CashbackFundingFormValues & ChargeFormValues,
>({
  idPrefix,
  control,
  sourceOptions,
  amountHelper,
  isSubmitting,
}: CashbackFundingFieldsProps<T>) => {
  const [isSheetOpen, setIsSheetOpen] = useState(false);
  const {
    field: { value: source, onChange: onSourceChange },
    fieldState: { error: sourceError },
  } = useController({
    control,
    name: "cashbackSource" as Path<T>,
    rules: { validate: cashbackSourceRule },
  });
  const selected = source as SelectOptionTypes | null;

  const openSheet = () => {
    if (!isSubmitting) {
      setIsSheetOpen(true);
    }
  };

  const closeSheet = () => setIsSheetOpen(false);

  const selectSource = (option: SelectOptionTypes) => {
    onSourceChange(option);
    closeSheet();
  };

  return (
    <>
      <Card>
        <CardLabel htmlFor={`${idPrefix}-cashback`}>
          {CASHBACK_AMOUNT_LABEL}
        </CardLabel>
        <FormMoneyInput
          id={`${idPrefix}-cashback`}
          name={"cashbackEur" as Path<T>}
          control={control}
          rules={{ validate: cashbackRule }}
          disabled={isSubmitting}
          placeholder="0.00"
        />
        <HelperText>{amountHelper}</HelperText>
      </Card>

      <RowsCard>
        <FormRow
          label={CASHBACK_SOURCE_LABEL}
          value={selected?.label}
          placeholder="Select account"
          error={sourceError?.message}
          onClick={openSheet}
        />
      </RowsCard>
      <HelperText>{CASHBACK_SOURCE_HELPER}</HelperText>

      <SelectSheet
        isOpen={isSheetOpen}
        title={CASHBACK_SOURCE_LABEL}
        options={sourceOptions}
        selectedValue={selected?.value}
        onSelect={selectSource}
        onClose={closeSheet}
      />
    </>
  );
};
